import sharedStyles from './shared.styles';

export default () => ({
  ...sharedStyles,
});
